import chatbotApi from '@/api/chatbot';

const SET_MESSAGES = 'SET_MESSAGES';
const ADD_MESSAGE = 'ADD_MESSAGE';
const SET_IS_OPEN = 'SET_IS_OPEN';
const SET_FEEDBACK_REQUEST = 'SET_FEEDBACK_REQUEST';

const state = {
  messages: [],
  isOpen: false,
  feedbackRequest: false
};

const getters = {
  getMessages: state => {
    return state.messages;
  },
  isOpen: state => {
    return state.isOpen;
  },
  getFeedbackRequest: state => {
    return state.feedbackRequest;
  }
};

const mutations = {
  [SET_MESSAGES] (state, messages) {
    state.messages = messages;
  },
  [ADD_MESSAGE] (state, message) {
    state.messages.push(message);
  },
  [SET_IS_OPEN] (state, isOpen) {
    state.isOpen = isOpen;
  },
  [SET_FEEDBACK_REQUEST] (state, feedbackRequest) {
    state.feedbackRequest = feedbackRequest;
  }
};

const actions = {
  addMessage ({ commit }, message) {
    commit(ADD_MESSAGE, message);
  },
  clearMessages ({ commit }) {
    commit(SET_MESSAGES, []);
  },
  toggleChatbot ({ commit, state }) {
    commit(SET_IS_OPEN, !state.isOpen);
  },
  openChatbot ({ commit }) {
    commit(SET_IS_OPEN, true);
  },
  closeChatbot ({ commit }) {
    commit(SET_IS_OPEN, false);
  },
  sendQuery ({ commit }, { context, query }) {
    return new Promise((resolve, reject) => {
      // Resetear el estado de feedback_request
      commit(SET_FEEDBACK_REQUEST, false);

      // Agregar mensaje del usuario
      const userMessage = {
        type: 'user',
        text: query,
        timestamp: new Date().toISOString()
      };
      commit(ADD_MESSAGE, userMessage);

      // Enviar la consulta al API
      const request = { query };
      chatbotApi.sendQuery(context, request)
        .then(response => {
          // Agregar respuestas del bot (pueden ser múltiples)
          if (response.answers && response.answers.length > 0) {
            response.answers.forEach(answer => {
              const botMessage = {
                type: 'bot',
                text: answer,
                timestamp: new Date().toISOString()
              };
              commit(ADD_MESSAGE, botMessage);
            });
          }

          // Actualizar el estado de feedback_request
          if (response.feedbackRequest !== undefined) {
            commit(SET_FEEDBACK_REQUEST, response.feedbackRequest);
          }

          resolve(response);
        })
        .catch(error => {
          // En caso de error, también lo añadimos como mensaje del bot
          const errorMessage = {
            type: 'bot',
            text: 'Lo siento, ha ocurrido un error al procesar tu consulta. Por favor, inténtalo de nuevo más tarde.',
            isError: true,
            timestamp: new Date().toISOString()
          };
          commit(ADD_MESSAGE, errorMessage);
          reject(error);
        });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/chatbot/index.js